module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.9e849369.jpg";